require('../../modules/es7.object.entries');
module.exports = require('../../modules/_core').Object.entries;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/library/fn/object/entries.js
// module id = wEtr
// module chunks = 1